import * as React from 'react'
import { Action, handleActions } from 'redux-actions'
import { TNotificationType } from '../../components/Notification/Notification'
import { addNotification, clearNotification } from './NotificationActions'

export interface INotification {
  content: React.ReactNode
  type: TNotificationType
}

class State {
  notification: INotification | null = null
}

export default handleActions<State, any>(
  {
    [String(addNotification)]: (state: State, { payload: notification }: Action<INotification>): State => ({
      ...state,
      notification,
    }),
    [String(clearNotification)]: (state: State): State => ({
      ...state,
      notification: null,
    }),
  },

  new State(),
)

export { State as NotificationState }
